import { createSignal, For } from "solid-js";
import type { MapChangeType } from "../../enums/map";
import { MAP_CHANGE_STATUS, MAP_CHANGE_TYPE } from "../../enums/map";
import { MapModalSheet } from "./MapModalSheet";
import {
  MAP_CHANGE_TYPES,
  mapChangeTypeLabel,
  mapTargetLaneForType,
  mapTargetRoleForType,
} from "./mapLabels";
import type { MapChange, MapChangeEdit } from "./mapTypes";

export function MapAdjustmentSheet(props: {
  change: MapChange;
  returnFocus: HTMLElement | null;
  onApply: (patch: MapChangeEdit) => void;
  onClose: () => void;
}) {
  const [title, setTitle] = createSignal(props.change.title);
  const [type, setType] = createSignal<MapChangeType>(props.change.type);
  const [targetGroup, setTargetGroup] = createSignal(props.change.targetGroup);
  const [proposedState, setProposedState] = createSignal(
    props.change.proposedState,
  );
  const [clientNote, setClientNote] = createSignal(props.change.clientNote);
  return (
    <MapModalSheet
      id="map-adjustment"
      kicker="Preview adjustment"
      title="Adjust this change"
      closeLabel="Close adjustment"
      returnFocus={props.returnFocus}
      onClose={props.onClose}
    >
      <form
        class="map-adjustment-form"
        onSubmit={(event) => {
          event.preventDefault();
          props.onApply({
            title: title().trim() || props.change.title,
            type: type(),
            targetLane: mapTargetLaneForType(type(), props.change.targetLane),
            targetRole: mapTargetRoleForType(type(), props.change.targetRole),
            targetGroup: targetGroup().trim() || props.change.targetGroup,
            proposedState: proposedState().trim() || props.change.proposedState,
            clientNote: clientNote().trim(),
            status:
              type() === MAP_CHANGE_TYPE.UNRESOLVED
                ? MAP_CHANGE_STATUS.UNRESOLVED
                : MAP_CHANGE_STATUS.ADJUSTED,
            adjusted: true,
          });
        }}
      >
        <label>
          <span>Change title</span>
          <input
            value={title()}
            onInput={(event) => setTitle(event.currentTarget.value)}
          />
        </label>
        <label>
          <span>Proposed action</span>
          <select
            value={type()}
            onChange={(event) =>
              setType(event.currentTarget.value as MapChangeType)
            }
          >
            <For each={MAP_CHANGE_TYPES}>
              {(value) => (
                <option value={value}>{mapChangeTypeLabel(value)}</option>
              )}
            </For>
          </select>
        </label>
        <label>
          <span>Target group or label</span>
          <input
            value={targetGroup()}
            onInput={(event) => setTargetGroup(event.currentTarget.value)}
          />
        </label>
        <label>
          <span>Proposed state</span>
          <textarea
            rows={4}
            value={proposedState()}
            onInput={(event) => setProposedState(event.currentTarget.value)}
          />
        </label>
        <label>
          <span>Client note</span>
          <textarea
            rows={3}
            value={clientNote()}
            placeholder="Add context for the decision"
            onInput={(event) => setClientNote(event.currentTarget.value)}
          />
        </label>
        <div class="map-sheet-actions">
          <button type="submit" class="signal-dark-button">
            Apply adjustment
          </button>
          <button type="button" onClick={props.onClose}>
            Cancel
          </button>
        </div>
        <p class="map-sheet-note">
          This adjustment is session-local. It does not save or publish a target
          estate.
        </p>
      </form>
    </MapModalSheet>
  );
}
